// @flow
import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import { asField } from 'informed';

/*
  Multi-select input that uses react-select library, to populate an informed field.
*/

type Props = {
  field: string,
  fieldApi: Object,
  initialValue: ?[string],
  options: [string],
}

class Multiselect extends Component<Props> {
  stringToOption(string) {
    return {
      value: string,
      label: string,
    };
  }

  onChange = (newValues) => {
    this.props.fieldApi.setTouched(true);
    this.props.fieldApi.setValue(newValues.map(x => x.value));
  }

  render() {
    const options = this.props.options.map(this.stringToOption);
    const defaultValue = this.props.initialValue ? this.props.initialValue.map(this.stringToOption) : [];
    return (
      <span>
        <CreatableSelect
          isMulti
          onChange={this.onChange}
          defaultValue={defaultValue}
          options={options}
          menuPlacement="auto"
        />
      </span>
    );
  }
}

const MultiselectComponent = asField(Multiselect);
export default MultiselectComponent;



// WEBPACK FOOTER //
// ./client/src/components/Multiselect.jsx